export enum ImagePillType {
    TEXT = 'TEXT',
    COUNT_DOWN = 'COUNT_DOWN',
}
